var map = {
	"./404_error.svg": 98,
	"./books.svg": 205,
	"./entertainment.svg": 206,
	"./gadgets.svg": 207,
	"./laptop.svg": 208,
	"./mathematics.svg": 209,
	"./movies.svg": 210,
	"./music.svg": 211,
	"./science.svg": 212
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 204;